(() => {
  if (window.pfgConsoleNavigationReady) return;
  window.pfgConsoleNavigationReady = true;
  const openMenus = () => [...document.querySelectorAll('[data-pfg-console-menu][open]')];
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-pfg-console-menu] > summary');
    const clickedMenu = trigger?.parentElement;
    openMenus().forEach(menu => {
      if ((clickedMenu && menu !== clickedMenu) || !menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  // Handle only the innermost disclosure; a second Escape closes the mobile panel.
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-pfg-console-menu][open]');
    if (!menu) return;
    event.preventDefault(); event.stopImmediatePropagation();
    menu.open = false; menu.querySelector('summary').focus();
  }, true);
  document.addEventListener('focusin', event => {
    openMenus().filter(menu => menu.classList.contains('pfg-console-menu--desktop') && !menu.contains(event.target)).forEach(menu => { menu.open = false; });
  });
})();
